import {
  AppointmentOverview,
  Title,
  DateMobilePickerRegion,
  PersonalDataForm,
  Remark,
  RegionPicker,
} from '@/components';

import Vue from 'vue';

import router from '@/router';

import validationFlow from '@/validation-flow';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  required,
} from 'vee-validate/dist/rules';

import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import _ from 'lodash';

export default {
  name: 'step6AppointmentInfoMobileRegion',
  components: {
    ValidationObserver,
    ValidationProvider,
    [AppointmentOverview.name]: AppointmentOverview,
    [Title.name]: Title,
    [DateMobilePickerRegion.name]: DateMobilePickerRegion,
    [PersonalDataForm.name]: PersonalDataForm,
    [Remark.name]: Remark,
    [RegionPicker.name]: RegionPicker,
  },
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      customerDataRaw: 'getCustomerDataRaw',
      loadingState: 'getLoadingState',
      isValidAppointment: 'getIsValidAppointmentMobileComp',
      appointmentPostObject: 'getAppointmentPostObject',
      timeOfArrival: 'getTimeOfArrival',
      appointmet: 'getHasAppointment',
      cat: 'getCat',
      momentOfArrival: 'getMomentsOfTimeOfArrival',
    }),
    timeOfArr: {
      get() {
        return this.timeOfArrival;
      },
      set(newModel) {
        // console.log(newModel);
        if (newModel != null) {
          this.setTimeOfArrival(newModel);
        }

        return newModel;
      },
    },
  },
  methods: {
    save() { },
    setValidationMessages() {
      // Vee-validate
      // Translations are added in the PersonalDataFormComponent
      extend('required', {
        ...required,
        message: Vue.prototype.$gettext('Validation - Required error'),
      });
    },
    ...mapActions('appointment', {
      setAppointmentMobile: 'SET_APPOINTMENT_MOBILE_BUS',
    }),
    ...mapMutations('appointment', {
      setCat: 'SET_CAT',
      setTimeOfArrival: 'SET_TIMEOFARRIVAL',
      setHasApp: 'SET_HASAPPOINTMENT',
    }),
    goToPreviousStep() {
      this.$router.push({
        name: 'step5TireInfo',
      });
    },
    confirmAppointment() {
      if (!this.loadingState) {
        const personalDataForm = this.$refs.personalDataForm.$refs.form;
        const timeOfArrForm = this.$refs.timeForm;
        const personalDataFormTitle = this.$refs.personalDataForm.$refs.formPersonalDataTitle;
        const validPersonalDataFormTitle = personalDataFormTitle.isValid();
        personalDataForm.validate().then((isValid) => {
          timeOfArrForm.validate().then((isValidTime) => {
            if (isValid && isValidTime) {
              if (this.isValidAppointment && validPersonalDataFormTitle && !this.loadingState) {
                this.setCat('tag');
                this.setAppointmentMobile(this.appointmentPostObject)
                  .then(() => {
                    this.setHasApp(true);
                    validationFlow.validateStep6AppointmentInfo();
                  }).catch(() => {
                    router.push({
                      name: 'error',
                    });
                  });
              }
            }
          });
        });
      }
    },
    debounceConfim: _.debounce(function () {
      this.confirmAppointment();
    }, 150),
  },
  created() {
    this.setValidationMessages();
  },
};
